/** The generate page. Plan text comes from plans.ts; shared labels from common.ts. */
export default {
  nav: {
    home: "Home",
  },
  hero: {
    eyebrow: "AI Generation",
    title: "Generate anything you imagine",
    subtitle: "Describe a scene, character, product, or mood and our AI will render it in seconds.",
  },
  modes: {
    image: "Image",
    video: "Video",
  },
  placeholder: {
    image:
      "A cinematic portrait of a fox under neon city lights, cinematic teal and cyan lighting, highly detailed, 8K resolution…",
    video: "A serene mountain timelapse at golden hour, dramatic clouds moving fast, cinematic 4K…",
  },
  duration: "Duration:",
  seconds_one: "{{count}}s",
  seconds_other: "{{count}}s",
  creditsLeft_one: "{{count}} point left",
  creditsLeft_other: "{{count}} points left",
  buyMoreCredits: "Buy more points",
  signInToEarn: "Sign in to earn points",
  buttons: {
    generating: "Generating…",
    generatingVideo: "Generating video…",
    wait_one: "Wait {{count}}s",
    wait_other: "Wait {{count}}s",
    generate: "Generate",
    generateVideo: "Generate Video",
    downloadImage: "Download Image",
  },
  errors: {
    blocked: "This prompt isn't allowed under our acceptable use rules (no sexual, violent, hateful or illegal content). Please describe something else — no points were charged.",
    outOfCredits: "You're out of points. Buy a points pack to keep generating.",
    videoCost: "A video costs 2 points. Buy a points pack to keep generating.",
    noImage: "No image was returned. Please try again.",
    imageFailed: "Something went wrong while generating.",
    noVideo: "No video URL returned. Please try again.",
    videoFailed: "Something went wrong.",
  },
  result: {
    title: "Result",
    videoTitle: "Video Result",
    fallback: "Fallback: {{provider}}",
    backupProvider: "backup",
    imageAlt: "AI generated result",
    prompt: "Prompt:",
    videoNote: "AI-generated image with cinematic Ken Burns animation. Click to pause or play.",
  },
  gallery: {
    recentImages: "Recent generations",
    recentVideos: "Recent videos",
    videoMeta_one: "{{count}}s · {{date}}",
    videoMeta_other: "{{count}}s · {{date}}",
  },
  plans: {
    eyebrow: "Plans",
    title: "Need more points?",
    subtitle: "Buy a points pack to keep generating — a one-time payment, not a subscription.",
    mostPopular: "Most popular",
    redirecting: "Redirecting to DSK…",
    secureCheckout: "Secure card checkout · One-time payment, no subscription · 30-day money-back guarantee",
  },
  player: {
    alt: "AI generated video",
    loop_one: "{{count}}s loop",
    loop_other: "{{count}}s loop",
  },
};
